export const MIN_COURSE_MAPPING_CREDITS = 0;
export const MAX_COURSE_MAPPING_CREDITS = 100;

export const clampCourseMappingCredits = (value: number): number =>
  Math.min(MAX_COURSE_MAPPING_CREDITS, Math.max(MIN_COURSE_MAPPING_CREDITS, value));

export const isAllowedCourseMappingCreditsDraft = (value: string): boolean => value === '' || /^\d*\.?\d*$/.test(value);

export const parseCourseMappingCreditsInput = (input: string): number | null | undefined => {
  const trimmed = input.trim();
  if (trimmed === '') {
    return null;
  }

  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) {
    return undefined;
  }

  return clampCourseMappingCredits(parsed);
};
